const el = '.kb-component--profile-overlay'
const DOM = document.querySelector(el)

export default function (Store) {
    if (DOM) {
        const userProfileId = DOM.dataset.userProfileId
        const userInformationUrl = DOM.dataset.userInformationUrl
        const frivilligOrdersUrl = DOM.dataset.frivilligOrdersUrl
        const frivilligUrl = DOM.dataset.frivilligUrl
        const cancerforumUrl = DOM.dataset.cancerforumUrl
        const stafetForLivetUrl = DOM.dataset.stafetForLivetUrl
        const logoutUrl = DOM.dataset.logoutUrl
        
        Store.commit('main/set_page_overlay_content_data', {
            userProfileId,
            userInformationUrl,
            frivilligOrdersUrl,
            frivilligUrl,
            cancerforumUrl,
            stafetForLivetUrl,
            logoutUrl
        })
    }
}
